import { Report } from './report.model';

export enum ReportCategory {
  device_configuration = 'device_configuration',
  event_publication = 'event_publication',
  events = 'events',
  financial = 'financial',
  interface = 'interface',
  referential = 'referential'
}

export interface ReportsByCategory {
  categoryName: ReportCategory;
  reports: Report[];
}

export const categoryOrder: { [key: string]: number } = {
  [ReportCategory.events]: 0,
  [ReportCategory.financial]: 1,
  [ReportCategory.interface]: 2,
  [ReportCategory.referential]: 3,
  [ReportCategory.device_configuration]: 4,
  [ReportCategory.event_publication]: 5
};
